import { TranslateService } from '@ngx-translate/core';

export function loadCreditCardCommonText(
  translateService: TranslateService
): any {
  return {
    creditCardInputLabel: translateService.instant('PAYMENT.CREDIT_CARD.CC'),
    creditCardAltText: translateService.instant(
      'PAYMENT.CREDIT_CARD.CC_ALT_TEXT'
    ),
    creditCardErrorMessage: translateService.instant(
      'PAYMENT.CREDIT_CARD.CREDIT_CARD_NUMBER_ERROR'
    ),
    ccDateInputlabel: translateService.instant('PAYMENT.CREDIT_CARD.EXPIRY'),
    ccDatePlaceholder: translateService.instant(
      'PAYMENT.CREDIT_CARD.EXPIRY_DATE_HINT'
    ),
    ccDateErrorMessage: translateService.instant(
      'PAYMENT.CREDIT_CARD.EXPIRY_DATE_ERROR'
    ),
    ccCVVInputlabel: translateService.instant('PAYMENT.CREDIT_CARD.CVV'),
    ccCVVPlaceholder: translateService.instant('PAYMENT.CREDIT_CARD.CVV_HINT'),
    ccCVVErrorMessage: translateService.instant(
      'PAYMENT.CREDIT_CARD.CVV_ERROR'
    ),
    popoverTriggerLabel: translateService.instant('PAYMENT.TRIGGER_LABEL'),
    popoverCloseLabel: translateService.instant('PAYMENT.CLOSE_LABEL'),
    popoverContent: translateService.instant('PAYMENT.CONTENT'),
  };
}
